import { observer } from 'mobx-react';

import SteppedComponent from 'js/components/pages/SteppedComponent';
import AppUser from 'js/stores/AppUser';
import AppState from 'js/stores/AppState';
import { isPhoneNumber } from 'js/services/Regex';
import { lightGrey1Color } from 'js/config/style';
import analytics from 'js/services/Analytics';

import BuyerSignupPageState from 'js/stores/pages/BuyerSignupPageState';

import FullName from './FullName';
import DeliveryDetails from './DeliveryDetails';
import SignUpSignIn from './SignUpSignIn';
import BuyerInfo from './BuyerInfo';
import {navigate, url} from "js/services/Network";

@observer
export default class BuyerSignupPage extends SteppedComponent {
  pageName = 'BuyerSignupPage';
  pageColor = lightGrey1Color;

  pageEvent = () => {
    AppState.previousPage === 'BuyerLandingPage' && analytics.goal('landing_conversion');
    //analytics.track('LP_clicked through');
    if (AppUser.isLoggedIn) {
      navigate(url('my-tokens-page',{},''));
    }
  };

  page = BuyerSignupPageState.create().setSteps(this, 'buyer-signup-page', [
    {
      name: 'name',
      label: 'Name',
      component: FullName,
      skipWhen: (page, step) => AppUser.isLoggedIn,
      isComplete: (page, step) => page.full_name.length > 0,
      onEnter: (page, step) => { /*analytics.page('BSF_viewed name entry')*/ },
      showStepMenu: false,
    },
    {
      name: 'delivery',
      label: 'Delivery',
      component: DeliveryDetails,
      skipWhen: (page, step) => AppUser.isLoggedIn,
      isComplete: (page, step) => page.address.hasAddress,
      onEnter: (page, step) => { /*analytics.page('BSF_viewed address') */},
      showStepMenu: false,
    },
    {
      name: 'signup',
      label: 'Signup',
      component: SignUpSignIn,
      skipWhen: (page, step) => AppUser.isLoggedIn,
      onEnter: (page, step) => { /*analytics.page('BSF_viewed signup')*/ },
      onLeave: (page, step) => {
        if (!page.full_name) {
          page.setFullName(AppUser.name || '');
        }
        if (!page.phone_number) {
          page.setPhoneNumber(AppUser.phone_number || '');
        }
      },
    },
    {
      name: 'info',
      label: 'Info',
      component: BuyerInfo,
      isComplete: (page, step) => !!(page.full_name.length && page.phone_number.match(isPhoneNumber)),
      skipWhen: (page, step) => step.isComplete(page, step),
      onEnter: (page, step) => { /*analytics.page('BSF_viewed user info')*/ },
    },
  ]);
}
